import React from "react";
import { FiPlus } from "react-icons/fi";
import { useTranslation } from "react-i18next";
import "./TimeRegistrationAddTimeButton.scss";

const TimeRegistrationAddTimeButton = ({
	onClick,
	disabled = false,
	title,
}) => {
	const { t } = useTranslation();
	const label = title || t("times.registrations.addTime");
	return (
		<button
			type="button"
			title={label}
			aria-label={label}
			disabled={disabled}
			className="time-registration-add-time-btn"
			onClick={onClick}
		>
			<FiPlus aria-hidden />
		</button>
	);
};

export default TimeRegistrationAddTimeButton;
